import { findAppearanceOption } from '%evp_theme/brandbook/appearance/appearanceOptions';
import {
    APPEARANCE_CHOICE_DARK,
    APPEARANCE_CHOICE_DEVICE,
    APPEARANCE_CHOICE_HIGH_CONTRAST,
    APPEARANCE_CHOICE_LIGHT,
} from '%evp_theme/brandbook/appearance/appearanceSchemes';
import isBackofficeRedesignEnabled from './isBackofficeRedesignEnabled';
import Translator from './translator';
import { router } from './router';

export const NOTICE_AREA_ORGANIZER = 'organizer';
export const NOTICE_AREA_BUYER = 'buyer';
export const NOTICE_AREA_PUBLIC = 'public';

export const ORGANIZER_CONTACTS_ROUTE = 'evp_ticket_frontend.static_page.contacts';
export const BUYER_CONTACTS_ROUTE = 'evp_ticket_frontend.static_page.buyer_contacts';

const CONTACTS_ROUTE_BY_AREA = Object.freeze({
    [NOTICE_AREA_ORGANIZER]: ORGANIZER_CONTACTS_ROUTE,
    [NOTICE_AREA_BUYER]: BUYER_CONTACTS_ROUTE,
    [NOTICE_AREA_PUBLIC]: BUYER_CONTACTS_ROUTE,
});

const NEW_LOOK_TRANSLATION_PREFIX = 'evp_ticket_frontend.page_notice.new_look';

export const NEW_LOOK_NOTICE_ID = 'new-look';
export const NEW_LOOK_TITLE_KEY = `${NEW_LOOK_TRANSLATION_PREFIX}.title`;
export const NEW_LOOK_APPEARANCE_KEY = `${NEW_LOOK_TRANSLATION_PREFIX}.appearance`;
export const NEW_LOOK_FEEDBACK_KEY = `${NEW_LOOK_TRANSLATION_PREFIX}.feedback`;

function translateAppearanceChoice(choice) {
    return Translator.trans(findAppearanceOption(choice).labelKey);
}

function translateAppearanceHint() {
    return Translator.trans(NEW_LOOK_APPEARANCE_KEY, {
        device: translateAppearanceChoice(APPEARANCE_CHOICE_DEVICE),
        light: translateAppearanceChoice(APPEARANCE_CHOICE_LIGHT),
        dark: translateAppearanceChoice(APPEARANCE_CHOICE_DARK),
        highContrast: translateAppearanceChoice(APPEARANCE_CHOICE_HIGH_CONTRAST),
    });
}

export const NEW_LOOK_NOTICE = Object.freeze({
    id: NEW_LOOK_NOTICE_ID,
    translationDomains: ['TicketFrontendBundle'],
    isDue: isBackofficeRedesignEnabled,
    describe: ({ area, appearanceChoiceAvailable }) => ({
        title: Translator.trans(NEW_LOOK_TITLE_KEY),
        text: appearanceChoiceAvailable ? translateAppearanceHint() : null,
        link: {
            label: Translator.trans(NEW_LOOK_FEEDBACK_KEY),
            url: router.generate(CONTACTS_ROUTE_BY_AREA[area]),
        },
    }),
});

const PAGE_NOTICES = Object.freeze([
    NEW_LOOK_NOTICE,
]);

export default PAGE_NOTICES;
